import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

const parseFrenchDateString = (raw: string): Date | null => {
    const trimmedValue = raw.trim();
    if (!trimmedValue) {
        return null;
    }

    const compactMatch = trimmedValue.match(/^(\d{2})(\d{2})(\d{4})$/);
    if (compactMatch) {
        const day = Number(compactMatch[1]);
        const month = Number(compactMatch[2]);
        const year = Number(compactMatch[3]);
        const parsedDate = new Date(year, month - 1, day);
        if (
            parsedDate.getFullYear() === year &&
            parsedDate.getMonth() === month - 1 &&
            parsedDate.getDate() === day
        ) {
            return parsedDate;
        }
        return null;
    }

    const frMatch = trimmedValue.match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/);
    if (frMatch) {
        const day = Number(frMatch[1]);
        const month = Number(frMatch[2]);
        const year = Number(frMatch[3]);
        const parsedDate = new Date(year, month - 1, day);
        if (
            parsedDate.getFullYear() === year &&
            parsedDate.getMonth() === month - 1 &&
            parsedDate.getDate() === day
        ) {
            return parsedDate;
        }
        return null;
    }

    return null;
};

export const patchNativeDateAdapterParse = (): void => {
    const proto = NativeDateAdapter.prototype as NativeDateAdapter & { __frParsePatched?: boolean };
    if (proto.__frParsePatched) {
        return;
    }

    const originalParse = proto.parse;
    proto.parse = function (value: unknown): Date | null {
        if (typeof value === 'string') {
            const parsedFr = parseFrenchDateString(value);
            if (parsedFr) {
                return parsedFr;
            }
        }
        return originalParse.call(this, value);
    };
    proto.__frParsePatched = true;
};

@Injectable()
export class AppNativeDateAdapter extends NativeDateAdapter {
    override parse(value: unknown): Date | null {
        if (typeof value === 'string') {
            const parsedFr = parseFrenchDateString(value);
            if (parsedFr) {
                return parsedFr;
            }
        }

        const date = value instanceof Date ? value : new Date(value as string | number);
        return this.isValid(date) ? date : null;
    }
}
